// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "./vuetify";
import App from "./App";
import router from "./router";
import {store} from "./store/store";
import * as types from "./store/types";
import "./lazyload";
import "./media-queries";

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App },
  mounted: function() {
    this.$store.dispatch(types.CHARGE_SENS_DISPOS);
    this.$store.dispatch(types.CHARGE_TYPURLS);
  }
});



// WEBPACK FOOTER //
// ./src/main.js